import React, { useRef, useState } from 'react';
//import { useDispatch } from 'react-redux';
import { Route, Navigate, useLocation } from 'react-router-dom';
import './Login.css';

import { TextField, Button, Box, Typography, CircularProgress, Alert, Container, Paper, Grid, FormControl } from '@mui/material';
import Divider from '@mui/material/Divider';
import { useLoginMutation } from './loginApiSlice';

import { UsuarioEstaLogado, UsuarioLogadoGet, UsuarioLogout, UsuarioSaveToken } from '../../utils/usuarioEstaLogado';
import { Token, getToken } from '../../types/Token';
import UserIp from '../../utils/fetch/getUserIp';
import axiosInstance from '../../app/axiosInstance';
import configUrls from '../../config/configUrls';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [login, { isLoading, error }] = useLoginMutation();
  const [alertVisible, setAlertVisible] = useState(false);
  const [msgAlert, setMsgAlert] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const ip = UserIp();

  const location = useLocation();
  let pegaURL = location.pathname;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const params = {
        login: username,
        password: password
      };

      const result = await login({ username, password });

      UsuarioLogout();

      if ('error' in result) {
        //dispatch(setToken(null));

        if ('status' in result.error) {
          if (result.error.status === 403) {
            setAlertVisible(true);
            setMsgAlert('Usuário ou senha inválidos!');
          } else {
            setAlertVisible(true);
            setMsgAlert('Erro ao efetuar o Login: ' + result.error.status.toString());
          }
        } else {
          setAlertVisible(true);
          setMsgAlert('Erro ao efetuar o Login: ' + result.error);
        }
        return;
      }

      if ('data' in result) {
        if (!result.data.setorId) {
          setAlertVisible(true);
          setMsgAlert('Usuário não possui setor vinculado. Algumas funcionalidades podem não estar disponíveis.');
          return; // interrompe o fluxo, pois não há setor
        }

        setAlertVisible(false);
        setMsgAlert('');
        //dispatch(setToken(result.data.token));
        const token: Token = getToken({
          token: result.data.token,
          usuario: username,
          ip: ip,
          tipo: result.data.tipo,
          id: result.data.id,
          setorId: result.data.setorId,
          setorNome: result.data.setorNome,
          tipoSite: result.data.tipoSite
        });

        //localStorage.setItem('token', result.data.token);
        UsuarioSaveToken(token);

        setSubmitted(true);
      } else {
        setAlertVisible(true);
        setMsgAlert('Erro ao efetuar o Login: Entre em contato com o admistrador do sistema.');
      }
    } catch (err) {
      console.log(err);
      // dispatch(setToken(null));
      setAlertVisible(true);
      setMsgAlert("'Failed to login:', err");
    }
  };

  if (submitted) {
    //return <Navigate to="/escolas" />;
    window.location.href = configUrls.SABER_HOME;

    if (pegaURL.includes('/site')) {
      window.location.href = configUrls.SITE_HOME;
    } else if (pegaURL.includes('/saber')) {
      window.location.href = configUrls.SABER_HOME;
    } else {
      window.location.href = configUrls.SITE_HOME;
    }
  }

  return (
    <Paper className="paper-box" sx={{ borderRadius: 5 }}>
      <form onSubmit={handleSubmit} method="POST">
        <Box mb={2}>
          <Typography variant="h6" component="h1">
            Login
          </Typography>
        </Box>

        <Divider orientation="horizontal" sx={{ mt: 2, mb: 2, borderColor: 'primary.main' }} />

        <Box>
          {alertVisible && (
            <>
              <Alert variant="filled" severity="error" aria-hidden="true" sx={{ marginBottom: '7px' }}>
                {msgAlert}
              </Alert>
              <Alert variant="filled" severity="warning" aria-hidden="true" sx={{ marginBottom: '16px' }}>
                Ou seu usuário pode estar desativado.
              </Alert>
            </>
          )}
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField required label="Usuário" name="username" onChange={e => setUsername(e.target.value)} size="small" />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField required type="password" label="Senha" name="password" onChange={e => setPassword(e.target.value)} size="small" />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="secondary" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24} /> : 'Login'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default Login;
